export default {
      id: "ic-game-arrow-rightwtext-usage",
      viewBox: "0 0 20 17",
      url: "/" + "images/icons.3.109.2.svg#ic-game-arrow-rightwtext-usage",
      toString: function () {
        return this.url;
      }
    }